import { render, staticRenderFns } from "./LaunchPage.vue?vue&type=template&id=67dfdfac&scoped=true&"
import script from "./LaunchPage.vue?vue&type=script&lang=js&"
export * from "./LaunchPage.vue?vue&type=script&lang=js&"
import style0 from "./LaunchPage.vue?vue&type=style&index=0&id=67dfdfac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dfdfac",
  null
  
)

export default component.exports